<template>
  <ul class="Usp" v-if="usp">
    <li
      v-for="(item, index) in usp"
      :key="index"
      class="UspItem"
    >
      <app-icon name="tick" />
      <div class="UspItem_text" v-html="item"></div>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'product-usp',

    props: {
      usp: {
        type: Array,
        required: true
      }
    }
  }
</script>

<style lang="scss">
  .Usp {
    margin-top: .25rem;
    padding: 0 .1rem;
    padding-bottom: 0;

    @include media(tablet) {
      border-top: none;
      padding-top: 0;
      margin-top: .35rem;
    }

    &Item {
      display: flex;
      margin-bottom: .2rem;
      font-size: .16rem;
      font-weight: 400;
      line-height: 1.2;
      color: #3c3c3c;

      h3,
      h4,
      h5,
      h6 {
        font-size: .18rem;
        line-height: 1;
        color: #3c3c3c;
        margin-bottom: .05rem;
      }

      .icon-tick {
        margin-right: .08rem;
        flex-shrink: 0;
        color: #5b8f22;
      }

      li {
        font-size: .16rem;
        line-height: 1.2;
      }
    }
  }
</style>
